// extracted by mini-css-extract-plugin
module.exports = {"container":"Address_container__3fHcr","large":"Address_large__2QBoi","small":"Address_small__1xT24"};